export default __webpack_public_path__ + "static/media/hot-pink.b3e2d47a.svg";